<template>
    <div class="row">
        <div class="col-12">
            <div class="position-fixe d-flex flex-row justify-content-between align-items-center mb-3">
                <h1>{{ $t("new-role") }}</h1>

                <button
                    type="button"
                    class="btn btn-primary"
                    @click="createRole"
                >
                    {{ $t('create') }}
                </button>
            </div>

            <div>
                <div v-if="validate && errors" class="alert alert-danger mb-3">{{ $t('required-fields-missing') }}</div>

                <TextInput v-model="role.name" :label="$t('name')" :error="validate && !role.name" />

                <TextAreaAutosize v-model="role.description" :label="$t('description')" />

                <PrivilegesEdit :role="role" />
            </div>

            <div v-if="validate && errors" class="alert alert-danger mb-3">{{ $t('required-fields-missing') }}</div>

            <button
                type="button"
                class="btn btn-primary"
                @click="createRole"
            >
                {{ $t('create') }}
            </button>
        </div>
    </div>
</template>

<script>
import PrivilegesEdit from 'src/components/Roles/PrivilegesEdit.vue'

export default {
    data() {
        return {
            role: {
                name: '',
                description: '',
                privileges: [],
            },
            validate: false,
            errors: false,
        }
    },
    watch: {
    	role: {
			handler(){
				this.$emit('dataChanged', true);
			},
			deep: true
    	}
    },
    methods: {
        async createRole() {
            this.validate = true
            this.errors = false

            if (!this.role.name) this.errors = true

            if (this.errors) return

            try {
                this.$store.commit('showBlockingSpinner')

                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/roles/create`, {
                    method: 'POST',
                    data: {
                        ...this.role,
                        privileges: JSON.stringify(this.role.privileges),
                    },
                })

                if (res.status === 'SUCCESS') {
                    this.$router.push(`/settings/users/roles/update/${res.role.id}`)
                    return
                }

                else {
                    this.$store.commit("openDialog", {
                        title: this.$t("something-went-wrong"),
                        content: this.$t('role-create-failed'),
                        confirmCallBack: function () {}
                    })
                }
            } catch (err) {
                this.$log.error.call(this, err)
            } finally {
                this.$store.commit('hideBlockingSpinner')
            }
        },
    },
    components: { PrivilegesEdit }
}
</script>
